import { Helmet } from "react-helmet-async";
import { Mail, MessageCircle, FileText, Clock } from "lucide-react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
const Suporte = () => {
  const channels = [
    {
      icon: Mail,
      title: "E-mail",
      description: "Envie sua dúvida e respondemos em até 24 horas.",
      action: "suporte@habitfrog.com",
      href: "mailto:suporte@habitfrog.com",
    },
    {
      icon: MessageCircle,
      title: "Chat no App",
      description: "Converse conosco diretamente pelo aplicativo.",
      action: "Abrir Chat",
      href: "/app",
    },
    {
      icon: FileText,
      title: "Central de Ajuda",
      description: "Artigos e tutoriais para resolver rapidamente.",
      action: "Ver Artigos",
      href: "/faq",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Suporte | HabitFrog - Ajuda e Atendimento</title>
        <meta name="description" content="Precisa de ajuda com o HabitFrog? Entre em contato pelo e-mail, chat ou consulte nossa central de ajuda. Estamos aqui para você." />
        <link rel="canonical" href="https://habitfrog.com/suporte" />
      </Helmet>

      <Header />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <header className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
              Como Podemos Ajudar?
            </h1>
            <p className="text-xl text-muted-foreground">
              Nossa equipe está pronta para ajudar você a aproveitar ao máximo o HabitFrog.
            </p>
          </header>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
            {channels.map((channel) => (
              <div key={channel.title} className="bg-card rounded-xl p-8 border text-center">
                <channel.icon className="w-12 h-12 text-primary mx-auto mb-4" />
                <h2 className="text-xl font-bold text-foreground mb-2">{channel.title}</h2>
                <p className="text-muted-foreground mb-4">{channel.description}</p>
                <Button variant="outline" asChild>
                  <a href={channel.href}>{channel.action}</a>
                </Button>
              </div>
            ))}
          </div>

          <div className="bg-card rounded-xl p-8 border max-w-2xl mx-auto">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-6 h-6 text-primary" />
              <h3 className="text-lg font-bold text-foreground">Horário de Atendimento</h3>
            </div>
            <p className="text-muted-foreground">
              Segunda a Sexta: 9h às 18h (horário de Brasília)<br />
              Tempo médio de resposta: 4 horas
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Suporte;
